<app-header></app-header>
<div class="lesson-container mb-12">
  <app-push-live-sidebar></app-push-live-sidebar>

  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
